import { PermissionNames } from 'webcommon/shared';

export enum ListFilterType {
  ControlMedicationHxFilter = 'ControlMedicationHxFilter',
  ControlMessageCenterFilter = 'ControlMessageCenterFilter',
  ControlResultsPatientFilter = 'ControlResultsPatientFilter',
  ControlResultTrackingFilter = 'ControlResultTrackingFilter'
}

export type ListFilterTypeSecurityId = {
  [ListFilterType.ControlMedicationHxFilter]: '';
  [ListFilterType.ControlResultTrackingFilter]: '';
  [ListFilterType.ControlMessageCenterFilter]: PermissionNames.MessageCenter;
  [ListFilterType.ControlResultsPatientFilter]: '';
  /** Remaining SecurityGroups for ListFilterType
   * batchprocess
   * documentbatch
   * cppfilter
   * audittrail
   * hl7errormessage
   * ViewHospitalRound
   * patientclinicalfilter
   * visitnotefilter
   * documentmanagement
   */
};
